<div id="login-page" class="login-page container">
  <div class="login-box">
    <div class="logo-container">
      <img id="black-logo" src="/assets/ProductioneerLogoBlack_Transparent.png" />
      <h4 class="product-title"><em>Portal</em></h4>
    </div>
    <div class="login-form my-4" *ngIf="isLoading">
      <app-loading-indicator [large]="true"></app-loading-indicator>
    </div>
    <form class="login-form" *ngIf="!isLoading" [formGroup]="loginForm" (ngSubmit)="onLogin()" autocomplete="on">
      <div class={{infoClass}} *ngIf="infoMessage" role="alert">
        {{infoMessage}}
      </div>
      <div class="error-container" *ngIf="error.isPresent">
        <p class="text-danger"><strong>{{error.message}}</strong></p>
      </div>
      <div class="form-group">
        <label for="username"><strong>Username</strong></label>
        <input type="text" class="form-control" placeholder="Enter your username" id="usernameInput" formControlName="username" trim="blur" cdkFocusInitial />
        <span *ngIf="loginForm['controls'].username.invalid && (loginForm['controls'].username.dirty || loginForm['controls'].username.touched)" class="text-danger">
          Username is required
        </span>
      </div>

      <div class="form-group">
        <label for="password"><strong>Password</strong></label>
        <input type="password" class="form-control" placeholder="Enter your password" id="passwordInput" formControlName="password" />
        <span *ngIf="loginForm['controls'].password.invalid && (loginForm['controls'].password.dirty || loginForm['controls'].password.touched)" class="text-danger">
          Password is required
        </span>
      </div>

      <div class="login-btn-container" *ngIf="!isSubmitting">
        <button type="submit" class="btn btn-primary btn-lg mi4-big-btn" [disabled]="!loginForm.valid">Login</button>
      </div>
      <div class="login-btn-container" *ngIf="isSubmitting">
        <button disabled class="btn btn-primary btn-lg mi4-big-btn"><span class="spinner-border" role="status"></span> Authenticating</button>
      </div>

      <div class="alternate-link-container">
        <a class="btn btn-outline-secondary mi4-big-link" routerLink="/forgotpassword">Forgot your password?</a>
      </div>
      <div class="alternate-link-container" *ngIf="showCreateActBtn">
        <a class="btn btn-warning mi4-big-link" href="https://mi4.com/create-new-productioneer-account/">Create Account</a>
      </div>
    </form>
  </div>
</div>
<app-footer></app-footer>
